import axios from 'axios';
import { defineStore } from 'pinia';
import { authStore } from '../stores/auth';
import { uniq } from 'lodash';
import dayjs from 'dayjs';

export const contractsStore = defineStore('contracts-store', {
  state: () => {
    return {
      allContracts: '',
    };
  },

  getters: {
    contracts(state) {
      return state.allContracts;
    },
    getDisctricts(state) {
      return uniq(
        state.allContracts.map((c) => {
          return c.rentalObject.district;
        })
      );
    },
  },

  actions: {
    async fetchContracts() {
      const response = await axios.get(
        process.env.VUE_APP_API_BASE_URL +
        'applicants/me/rentcontracts',
        authStore().authConfig
      );
      try {
        this.allContracts = response.data;
      } catch (err) {
        this.allContracts = '';
        console.error('Error loading Contracts:', err);
        return err;
      }
    },

    async terminationRequest(contractNumber) {
      const desiredMoveDate = dayjs().add(3, 'month').endOf('month').format('YYYY-MM-DD');
      const response = await axios.post(process.env.VUE_APP_API_BASE_URL + 'applicants/me/rentContracts/terminationRequest', {
        contractNumber: contractNumber,
        desiredMoveDate: desiredMoveDate
      }, authStore().authConfig);
      try {
        if (response.status === 204) {
          this.fetchContracts();
        }
      } catch (err) {
        console.error("Failed to terminmate contract:", err);
        return err;
      }
    }
  },
});
